import { StatusPillType } from '../../pills/general-status-pill/status-pill-type.enum';

export class DropdownItem<T = unknown> {
  public title: string;
  public value: T;
  public disabled: boolean = false;
  public statusPillType?: StatusPillType;

  constructor(title: string, value: T, disabled: boolean = false, statusPillType?: StatusPillType) {
    this.title = title;
    this.value = value;
    this.disabled = disabled;
    this.statusPillType = statusPillType;
  }
}
